import { render, staticRenderFns } from "./ChatsTable.vue?vue&type=template&id=5c437798&"
import script from "./ChatsTable.vue?vue&type=script&lang=js&"
export * from "./ChatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports